import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { WAVE_BG_URL } from "../constants";
import { Reveal, FrequencyWave } from "./motion";

const Resonance = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      id="resonance"
      ref={ref}
      data-testid="resonance-section"
      className="relative overflow-hidden py-40 lg:py-56"
    >
      <motion.div style={{ y: bgY }} className="absolute inset-0 scale-125">
        <img
          src={WAVE_BG_URL}
          alt=""
          aria-hidden="true"
          className="h-full w-full object-cover opacity-[0.14]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/70 to-[#050505]" />
      </motion.div>

      <div className="pointer-events-none absolute inset-0 flex flex-col justify-center gap-10 opacity-60">
        <FrequencyWave className="h-24 w-full" opacity={0.5} />
        <FrequencyWave className="h-32 w-full" opacity={0.8} />
        <FrequencyWave className="h-24 w-full" opacity={0.4} />
      </div>

      <div className="relative z-10 mx-auto max-w-4xl px-6 text-center">
        <Reveal>
          <h2
            data-testid="resonance-headline"
            className="font-serif-display text-4xl font-light tracking-tight text-white sm:text-5xl lg:text-6xl"
          >
            VOICE. <span className="text-gold-gradient">HEART.</span>{" "}
            <span className="text-silver-gradient">RESONANCE.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mx-auto mt-10 max-w-xl text-base font-extralight text-white/70 md:text-lg">
            A voice does more than communicate information.
          </p>
          <div className="font-serif-display mt-8 space-y-2 text-xl font-light italic text-white/85 md:text-2xl">
            {["It carries emotion.", "Intention.", "History.", "Rhythm.", "Presence."].map((line) => (
              <p key={line}>{line}</p>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="mx-auto mt-10 max-w-2xl text-sm font-extralight leading-relaxed text-white/55 md:text-base">
            The SEAL Collective is especially interested in the places where voice and human experience
            intersect — in music, personal transformation, leadership, wellness, creativity, and technology.
          </p>
          <p className="mx-auto mt-6 max-w-xl text-sm font-extralight text-white/55 md:text-base">
            Because sometimes the next shift does not begin with thinking harder.
          </p>
        </Reveal>

        <Reveal delay={0.2}>
          <p
            data-testid="resonance-keyline"
            className="font-serif-display mx-auto mt-12 max-w-3xl text-2xl font-light leading-snug text-gold-gradient sm:text-3xl lg:text-4xl"
          >
            SOMETIMES IT BEGINS WITH HEARING YOURSELF DIFFERENTLY.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Resonance;
